module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/cz-1b3452b8ce83987fb494ea9ac5f49522.svg";